import {getMapping, selectMeterByIds} from '@/api/Meter'
import {format} from '@/utils/time'

let ids = ''
/* 能耗单元id集合*/
let mapping = []

/* 能耗单元id和能耗单元名称映射*/

/**
 * 根据时间戳筛选数据
 * @param data
 * @param xAix
 * @param xAixIndex
 * @returns {*}
 */
export function formartData(data, xAix, xAixIndex) {
  if (data === undefined || data === null) return {}
  const length = xAix.length
  const array = new Array(length)
  for (const i in xAix) {
    const time = xAix[i]
    const dayData = getData(data, time)

    const index = xAixIndex[time]
    if (dayData === undefined || dayData === null) {
      array[index] = {time: time}
    } else {
      array[index] = dayData
    }
  }
  array.name = data.name
  return array
}

/**
 * 根据时间戳获取数据
 * @param data
 * @param key
 * @returns {*}
 */
function getData(data, key) {
  for (const i in data) {
    if (data[i].time === key) return data[i]
  }
}

export function formatDataByType(data) {
  let energy = [];
  let money = [];
  for (let i = 0; i < data.length; i++) {
    if (data[i].energyItemId === '16396ef1-06a1-4896-a3d6-6c3eb17df360' || data[i].energyItemId === '480d65f3-a47e-427c-b649-b3d179b3c0e2') {
      energy.push(data[i])
    }
    else if (data[i].energyItemId === '11d11b4d-d0d6-4953-9273-648b0c800992' || data[i].energyItemId === '10b8724e-8439-414f-a510-902f53594ef6') {
      money.push(data[i])
    }
  }
  return {energy: energy, money: money}
}

/**
 * 根据能耗单元id数据分组
 * @param data
 * @returns {Array}
 */
export function formartDataById(data, meters, xAix) {


  let set = []
  let map = new Map()
  let timeSet = []
  for (let i in xAix)
    timeSet[i] = {time: xAix[i]}

  for (let i in meters) {
    map.set(meters[i].energyId, [])
    map.get(meters[i].energyId).name = meters[i].name
    for (let j in data) {
      if (data[j].energyUnitId == meters[i].energyId)
        map.get(meters[i].energyId).push(data[j])
    }
  }
  map.forEach(value => {
    console.log(value)
    if (value.length == 0) {

      let meterName = value.name
      value = Object.assign([],timeSet)
      value.name = meterName
      console.log(meterName)
    }
    set.push(value)
  })
  return set


  /*const set = []
  let array = []
  let energyUnitId = null
  let index = 0
  ids = ''

  for (let i = 0; i < data.length; i++) {
    /!* if( i === 20) debugger*!/
    if (energyUnitId === null) {
      energyUnitId = data[i].energyUnitId
      ids += energyUnitId + ','
    } else if (data[i].energyUnitId !== energyUnitId) {
      set.push(array)
      array = []
      index = 0
      energyUnitId = data[i].energyUnitId
      ids += energyUnitId + ','
    }
    array[index] = data[i]
    ++index
  }
  set.push(array)
  return set*/
}

export function concatAllData(moneyData, energyData, meters, xAix, customerName) {
  let finallyData = []
  let timeMoneyData, timeEnergyData
  for (let j in meters) {
    for (let i in xAix) {

      let time = xAix[i]
      let energyUnitId = meters[j].energyId
      if (moneyData !== null && moneyData !== undefined)
        timeMoneyData = getDataByEnergyTimeAndEnergyUnitId(moneyData, time, energyUnitId)
      if (energyData !== null && energyData !== undefined)
        timeEnergyData = getDataByEnergyTimeAndEnergyUnitId(energyData, time, energyUnitId)
      /*let timeMeters = getDataByEnergyTimeAndEnergyUnitId(meters, timeMoneyData.energyUnitId)*/
      finallyData.push({
        customerName: customerName,
        time: xAix[i],
        meterId: meters[j],
        timeMoneyData: timeMoneyData,
        timeEnergyData: timeEnergyData
      })
    }
  }

  return finallyData
}

function getDataByEnergyTimeAndEnergyUnitId(data, time, energyUnitId) {
  for (let i in data) {
    if (data[i].energyUnitId === energyUnitId && data[i].time === time) return data[i]
  }
}


export function addTitle(ids, array) {
  return new Promise((resolve, reject) => {
    getMapping(ids).then(response => {
      if (response.code === 200) {
        mapping = response.infoJson
        for (let i in array) {
          for (let j in array[i]) {
            if (array[i][j].energyUnitId !== undefined) {
              array[i].name = get(array[i][j].energyUnitId)
              break
            }

          }
        }
        resolve(array)
      } else {
        reject(response.message)
      }
    }).catch(err => {
      reject(err)
    })
  })
}

function get(id) {
  for (let i in mapping) {
    if (i === id) {
      return mapping[i]
    }
  }
}

/**
 * 格式化数据,将属性改为对应中文、格式化数据
 * @param data
 * @returns {*}
 */
export function formatTitle(data, lable) {
  let labelName = lable + ''

  try {
    let array = [];
    for (let i in data) {

      let map = {}
      map["时间"] = format(data[i].time, 'YYYY-MM-DD HH:mm:ss')

      map["用户名称"] = tableStringFormat(data[i].customerName)

      map["仪表名称"] = tableStringFormat(data[i].meterId.name)

      if (data[i].meterId !== undefined && data[i].meterId !== null)
        map["仪表编号"] = tableStringFormat(data[i].meterId.code)
      else map["仪表编号"] = '-'

      if (data[i].meterId !== undefined && data[i].meterId !== null)
        map["表号"] = tableStringFormat(data[i].meterId.meterNum)
      else map["表号"] = '-'

      if (data[i].meterId !== undefined && data[i].meterId !== null)
        map["能耗类型"] = tableStringFormat(data[i].meterId.energyType)
      else map["能耗类型"] = '-'

      if (data[i].timeEnergyData !== undefined && data[i].timeEnergyData !== null)
        map[labelName] = tableStringFormat(data[i].timeEnergyData.energyValue)
      else map[labelName] = '-'

      if (data[i].timeMoneyData !== undefined && data[i].timeMoneyData !== null)
        map["能耗费用(元)"] = tableStringFormat(data[i].timeMoneyData.energyValue)
      else map["能耗费用(元)"] = '-'

      array.push(map)
    }
    return array;
  } catch (e) {
    return null;
  }

}

function myCheck(...values) { /* true为空 */
  if (typeof values === undefined || values === null || values === '') return true
  let ret = true
  for (let i = 0; i < values.length; i++) {
    ret = typeof values[i] === undefined || values[i] === null || values[i] === ''
    if (ret === false) break
  }
  return ret
}

export function selectMeters(ids) {
  return new Promise((resolve, reject) => {
    selectMeterByIds(ids).then(response => {
      if (response.code === 200) {

        resolve(response.infoJson)
      } else {
        reject(response.message)
      }
    }).catch(err => {
      reject(err)
    })
  })
}

function tableStringFormat(cellValue) { // 表格中字符串格式化
  if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
    return cellValue
  }
  return '--'
}